__turbopack_context__.v({
  "icon": "BlurTooltipMap-module-scss-module__z1jRhW__icon",
  "icon__svg": "BlurTooltipMap-module-scss-module__z1jRhW__icon__svg",
  "svgBlock": "BlurTooltipMap-module-scss-module__z1jRhW__svgBlock",
  "svgClose": "BlurTooltipMap-module-scss-module__z1jRhW__svgClose",
  "svgOpen": "BlurTooltipMap-module-scss-module__z1jRhW__svgOpen",
  "titleSvg": "BlurTooltipMap-module-scss-module__z1jRhW__titleSvg",
});
